import React from 'react'
import styled from 'styled-components'
import {
  Label as LabelReactstrap
} from 'reactstrap'

const Label = styled(LabelReactstrap)`
  color: ${({ theme }) => theme.colors.text.gray};
  font-weight: 300;
  margin-bottom: 4px;
  margin-right: 16px;
  margin-top: 4px;

  &:last-child {
    margin-bottom: 0;
    margin-right: 0;
  }

  & input {
    margin-right: 8px;
  }
`

export default class InputGroup extends React.PureComponent {
  render() {
    const baseItem = { name: 'Todos', value: 'all' };

    return (
      <div className={ this.props.className }>
        { this.props.hasBaseItem &&
          <Label>
            { this.props.children(baseItem) }
            { baseItem.name }
          </Label>
        }
        { this.props.items.map((item) => (
          <Label key={ `${item.name}-${item.value}` }>
            { this.props.children(item) }
            { item.name }
          </Label>
        )) }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/atoms/InputGroup/InputGroup.js